module.exports = __webpack_public_path__ + "static/scale-model-of-victory-monument-in-chicago-illinois-85487de9d79363550ee828452c0e840d.png";